import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const PopularDestinations = () => {
  const [destinations, setDestinations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDestinations = async () => {
      try {
        const apiBase = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000/api/v1';
        const response = await fetch(`${apiBase}/featuredcities`);
        const data = await response.json();
        if (data.status) {
          setDestinations(data.data);
        }
      } catch (err) {
        console.error("Error fetching popular destinations:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchDestinations();
  }, []);

  const getImageUrl = (imagePath) => {
    if (!imagePath) return 'https://images.unsplash.com/photo-1500835556837-99ac94a94552?w=500&h=500&fit=crop';
    if (imagePath.startsWith('http')) return imagePath;
    const apiBase = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000/api/v1';
    return `${apiBase.replace('/api/v1', '')}/storage/${imagePath}`;
  };

  if (loading || destinations.length === 0) return null;

  return (
    <section className="py-4 py-md-5 bg-white">
      <div className="container p-0">
        {/* Title and Subtitle - Hidden on mobile */}
        <h2 className="fw-bold text-center mb-3 d-none d-md-block" style={{ fontSize: '2rem' }}>
          Popular Destinations
        </h2>
        <p className="text-muted text-center mb-4 d-none d-md-block">
          Explore top cities for your next trip
        </p>

        {/* Desktop Grid */}
        <div className="d-none d-md-flex gap-4 desktop-scroll-wrapper pb-3 pt-2">
          {destinations.map((dest, index) => (
            <Link
              to={`/search?city=${dest.name}`}
              className="text-decoration-none text-dark flex-shrink-0 destination-link" key={index}>
              <div className="destination-card text-center">
                <div className="img-wrapper overflow-hidden mx-auto rounded-circle" style={{ width: '120px', height: '120px' }}>
                  <img
                    src={getImageUrl(dest.image)}
                    alt={dest.name}
                    className="img-fluid w-100 h-100 object-fit-cover rounded-circle"
                  />
                </div>
                <div className="pt-3">
                  <h5 className="fw-semibold mb-0">{dest.name}</h5>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Mobile Slider */}
        <div className="d-md-none mobile-scroll-wrapper">
          <div className="d-flex flex-nowrap gap-3 px-3 py-1">
            {destinations.map((dest, index) => (
              <Link
                to={`/search?city=${dest.name}`}
                key={index}
                className="flex-shrink-0 text-center destination-circle-link text-decoration-none"
                style={{ width: '72px' }}
              >
                <div 
                  className="img-wrapper overflow-hidden mx-auto rounded-circle shadow-sm" 
                  style={{ 
                    width: '64px', 
                    height: '64px',
                    border: '2px solid #ffffff',
                    outline: '2px solid #e2e8f0',
                    transition: 'all 0.2s ease-in-out'
                  }}
                >
                  <img
                    src={getImageUrl(dest.image)}
                    alt={dest.name}
                    className="img-fluid w-100 h-100 object-fit-cover rounded-circle"
                  />
                </div>
                <div className="pt-2">
                  <span className="fw-bold text-gray-800" style={{ fontSize: '12px' }}>{dest.name}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Styles */}
      <style dangerouslySetInnerHTML={{ __html: `
        .img-wrapper img {
          transition: transform 0.3s ease;
        }

        .destination-circle-link:active .img-wrapper,
        .destination-circle-link:hover .img-wrapper {
          transform: scale(1.06);
          outline-color: #10b981 !important;
        }

        .img-wrapper:hover img {
          transform: scale(1.05);
        }

        .destination-link {
          width: calc(20% - 1.2rem);
          min-width: 150px;
        }

        .mobile-scroll-wrapper, .desktop-scroll-wrapper {
          overflow-x: auto;
          flex-wrap: nowrap;
          -ms-overflow-style: none;  /* IE and Edge */
          scrollbar-width: none;     /* Firefox */
        }

        .mobile-scroll-wrapper::-webkit-scrollbar,
        .desktop-scroll-wrapper::-webkit-scrollbar {
          display: none;             /* Chrome, Safari, Opera */
        }
      `}} />
    </section>
  );
};

export default PopularDestinations;
